import styled, { css } from 'styled-components';
import { media } from '../../utilities/style-utilities';
import { emy, fontUbuntuLight } from '../../utilities/utilities';

const Paragraph = styled.p`
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-size: ${emy(18.5)};
    margin: 1rem 0;
    font-weight: 500;
    text-rendering: optimizeLegibility;

    ${props => props.bold && css`
        font-weight: 700;
        font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    `};
    text-align: ${props => props.center ? 'center' : 'left'};
    ${ media.mobile`
        font-size: 0.9em;
    `}
    ${props => props.mbottom && css`
        margin-bottom: ${props => props.mbottom ? props.mbottom : 0};
    `};
`;

export default Paragraph;


// WEBPACK FOOTER //
// ./src/collections/Paragraph/Paragraph.js